import axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";

/**
 * AXIOS WRAPPER
 * @param includeHeader
 * @param additionalConfig
 * @param additionalHeader
 */
const httpBase = (
  includeHeader: boolean = false,
  additionalConfig: AxiosRequestConfig<any> = {},
  additionalHeader: AxiosRequestHeaders = {}
) => {
  /**
   * AUTH TOKEN
   */
  const token = localStorage.getItem("token");

  /**
   * AXIOS INSTANCE
   */
  const instance = axios.create({
    headers: {
      "Access-Control-Allow-Origin": "*",
      authorization: `Bearer ${token}`,
      ...additionalHeader,
    },
    // FIXME: for production
    baseURL: "https://ultimatetrekkingnepal.com",
    ...additionalConfig,
  });

  /**
   * RESPONSE INTERCEPTORS
   */
  instance.interceptors.response.use(
    // Success response interceptors
    (response) => {
      if (includeHeader) {
        return response.data;
      }
      return response;
    },
    // Error response interceptors
    (error) => {
      const statusCode = error?.response?.status;

      // // UNAUTHORIZED
      // if (statusCode === httpStatus.UNAUTHORIZED) {
      //     // HANDLE UNAUTHORIZED
      // } else if (statusCode === httpStatus.NOT_FOUND) {
      //     redirect('/404')
      // } else if (statusCode === httpStatus.FORBIDDEN) {
      //     redirect('/403')
      // }

      return Promise.reject(error);
    }
  );

  return instance;
};

export default httpBase;
